import React from 'react';

const STATUS_BADGE = {
  confirmed: 'bg-emerald-50 text-emerald-700',
  amended: 'bg-amber-50 text-amber-700',
  cancelled: 'bg-rose-50 text-rose-700',
  booked: 'bg-slate-100 text-slate-600',
};

const fmt = (n) => '\u20B9' + Number(n || 0).toLocaleString('en-IN', { maximumFractionDigits: 2 });

export default function VendorLedgerRow({ row, idx }) {
  const badgeClass = STATUS_BADGE[row.bookingStatus] || 'bg-slate-100 text-slate-600';
  return (
    <tr className="border-t border-slate-100" data-testid={'ledger-row-' + idx}>
      <td className="px-3 py-2">{row.vendorName || row.vendorId || '\u2014'}</td>
      <td className="px-3 py-2">{row.guestName} <span className="text-slate-400">{'\u00b7 ' + row.destination}</span></td>
      <td className="px-3 py-2 capitalize">{row.category}</td>
      <td className="px-3 py-2">{row.bookingRef || '\u2014'}</td>
      <td className="px-3 py-2">
        <span className={'px-2 py-0.5 rounded-full text-[10px] font-semibold capitalize ' + badgeClass}>
          {row.bookingStatus}
        </span>
      </td>
      <td className="px-3 py-2 text-right font-mono">{fmt(row.costInr)}</td>
      <td className="px-3 py-2 text-right font-mono text-teal-700">{fmt(row.computedRevenue)}</td>
    </tr>
  );
}
